import * as React from 'react';
import { ILegalForm } from '@models';
import { useTranslation, G, useResolveName } from '@components';
// import './RestrictWorker.scss';

interface IProps {
    workId: number;
    oldValues: IFormValues;
    editRestriction: Function;
    handleClose: () => void;
    handleToast: (message: string, success: boolean) => void;
    canEditRestriction: boolean;
    legalForms: ILegalForm[]
}

interface IFormValues {
    id: number;
    workId: number;
    name: string;
    code: string;
    legalFormId: number;
    providerCode: string;
    contractorContactPerson: string;
    contractorEmail: string;
    contractorPhone: string;
    contractorId: number;
    applicantName: string;
    applicantEmail: string;
    reason: string;
    remarks: string;
    date: string;
}

export function EditRestriction(props: IProps) {

    const { t } = useTranslation();
    const [disabled, setDisabled] = React.useState(false);

    const [applicantName, setApplicantName] = React.useState(props.oldValues.applicantName);
    const [applicantEmail, setApplicantEmail] = React.useState(props.oldValues.applicantEmail);
    const [reason, setReason] = React.useState(props.oldValues.reason);
    const [remarks, setRemarks] = React.useState(props.oldValues.remarks);

    const handleSave = async () => {
        setDisabled(true);

        const id = props.oldValues.id;
        const applicantNameValue = applicantName.trim();
        const applicantEmailValue = applicantEmail.trim();
        const reasonValue = reason.trim();
        const remarksValue = remarks.trim();


        const response = await props.editRestriction(id, applicantNameValue, applicantEmailValue, reasonValue, remarksValue)

        if(response.data.editContractorRestriction.isError || response.data.editContractorRestriction.value == 0) {
            props.handleToast(t('Error while editing restriction'), false);
        }else{
            props.handleClose();
        }
    }

    const resolveLegalForm = useResolveName(props.legalForms, { translate: true });

    return (
        <div className='restrict-contractor-dialog'>
            <G label={t('Contractor.Name')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.name}
                />
            </G>
            <G label={t('CIF')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.code}
                />
            </G>
            <G label={t('Legal form')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={resolveLegalForm(props.oldValues.legalFormId)}
                />
            </G>
             <G label={t('Provider code')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.providerCode}
                />
            </G>
            <G label={t('Contact person')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.contractorContactPerson}
                />
            </G>
            <G label={t('contractor.invitation.email')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.contractorEmail}
                />
            </G>
            <G label={t('Phone')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.contractorPhone}
                />
            </G>
            <G label={t('Applicant')}>
                <input
                    disabled={!props.canEditRestriction}
                    className='c'
                    type='text'
                    value={applicantName}
                    onChange={(e) => setApplicantName(e.target.value)}
                />
            </G>
            <G label={t('Applicant email')}>
                <input
                    disabled={!props.canEditRestriction}
                    className='c'
                    type='text'
                    value={applicantEmail}
                    onChange={(e) => setApplicantEmail(e.target.value)}
                />
            </G>
            <G label={t('Motive')} className='restriction-reason'>
                <textarea
                    disabled={!props.canEditRestriction}
                    className='c'
                    value={reason}
                    onChange={(e) => { setReason(e.target.value) }}
                />
            </G>
            <G label={t('Remarks')} className='restriction-remarks'>
                <textarea
                    disabled={!props.canEditRestriction}
                    className='c'
                    value={remarks}
                    onChange={(e) => { setRemarks(e.target.value) }}
                />
            </G>
            <div className='c' />
            {props.canEditRestriction && <div className='r'>
                <span className='e' />

                <button
                    className='primary'
                    disabled={disabled}
                    onClick={() => {
                        handleSave();
                    }}>
                    {t('Edit')}
                </button>
            </div>}
        </div>
    )
}